import {
   HealthcareProviderLocation,
   HealthcareProviderLocationQuery,
} from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { UseCqrsQueryResult, useCqrsSearch } from '@dreryk/command-query-react-common';

export const useHealthcareLocationQuery = (): UseCqrsQueryResult<HealthcareProviderLocation[]> => {
   return useCqrsSearch(() => {
      return new HealthcareProviderLocationQuery();
   });
};
